import httpUtil from '../base/httpUtil'

// 登录注册绑定用到的接口
export default {

    //发送验证码
    sendCode(that, phone, callback, error) {
        let params = {}
        params.phone = phone

        httpUtil.httpPost(that, '/v3/api/user/phone/send_register_sms', params, function (res) {
            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })
    },

    //检测验证码
    checkPhoneCode(that, phone, code,callback, error) {
        let params = {}
        params.phone = phone
        params.code = code
        // httpUtil.httpGet(that, '/v3/api/user/phone/check_phone_code', params, function (res) {
            httpUtil.httpGet(that, '/v3/api/user/check_phone_code', params, function (res) {

            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err get' + err)
            if (error) {
                error(err)
            }
        })
    },
    // 发送手机绑定用的验证码
    sendBindSms(that, phone, callback, error) {
        let params = {}
        params.phone = phone
        httpUtil.httpPost(that, '/v3/api/user/phone/send_check_phone_sms', params, function (res) {
            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })
    },
    //手机号登录
    phone_login(that, phone,code, callback, error) {


        let params = {}
        params.phone = phone
        params.code = code
        httpUtil.httpPost(that, '/v3/api/user/phone_login', params, function (res) {
            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })
    },
    //手机号注册
    phone_reg(that, params, callback, error) {
        // let params = {}
        // params.phone = phone
        params.password = ""
        // params.code = code
        httpUtil.httpPost(that, '/v3/api/user/phone_register', params, function (res) {
            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })
    },
    other_login(that, referer, callback, error) {
        //跳转到h5授权登录页
        let redirectUrl=window.BASE_URL+'/v3/api/user/h5/wx_login?referer='+encodeURIComponent(referer)
        location.href=redirectUrl
    },
    checkLogin(that){
        let ktxToken=localStorage.getItem(that.GLOBAL.KTX_TOKEN_NAME)
        console.log('checklogin query.token='+that.$route.query.ktxtoken)
        if(that.$route.query.ktxtoken&&(ktxToken==null||ktxToken=='')){
            console.log('checklogin has_querytoken,not_localtoken')
            this.updateToken(that,that.$route.query.ktxtoken)
            ktxToken=localStorage.getItem(that.GLOBAL.KTX_TOKEN_NAME)
        }

        if(ktxToken==null||ktxToken==''){
            console.log('checklogin notlogin!')
            return false
        }
        console.log('checklogin haslogin')
        return true
    },
    getToken(that){
        let ktxToken=localStorage.getItem(that.GLOBAL.KTX_TOKEN_NAME)
        return ktxToken
    },
    updateToken(that,token){
        console.log('updateToken:'+token)
       localStorage.setItem(that.GLOBAL.KTX_TOKEN_NAME,token)
        // sessionStorage.setItem(that.GLOBAL.KTX_TOKEN_NAME,token)
    },
    removeToken(that,token){
        console.log('removeToken:'+token)
        if(that){
            localStorage.removeItem(that.GLOBAL.KTX_TOKEN_NAME)
            // sessionStorage.removeItem(that.GLOBAL.KTX_TOKEN_NAME)
        }else{
            localStorage.removeItem('ktxToken')
            localStorage.removeItem('ktxToken_Dev')
            localStorage.removeItem('ktxToken_Test')

            // sessionStorage.removeItem('ktxToken')
            // sessionStorage.removeItem('ktxToken_Dev')
            // sessionStorage.removeItem('ktxToken_Test')

        }
        console.log('removeToken:'+token)

    },
    getOpenId(that){
        // alert('getopenId1')
        console.log('getOpenId 1')
            if(that.$route.query.openid){
                console.log('getOpenId set')
                localStorage.setItem('openId',that.$route.query.openid)
            }
        console.log('getOpenId 2')
            if(!localStorage.getItem('openId')){
                //todo: 没有openid的情况应该提示重新登录

                console.log('getOpenId 3')
                //授权跳转
                // let referer=window.BASE_URL+'/web/webproject/sharedetail/index.html'+location.hash
                let referer=location.href
                let redirectUrl=window.BASE_URL+'/v3/api/user/h5/wx_auth?referer='+encodeURIComponent(referer)
                // alert(redirectUrl)
                // alert(redirectUrl)
                location.href=redirectUrl

            }
        console.log('getOpenId 4'+localStorage.getItem('openId'))
            return localStorage.getItem('openId')
    },
    updateOpenId(that){
        console.log('getOpenId 1')
        if(that.$route.query.openid){
            // console.log('getOpenId set')
            localStorage.setItem('openId',that.$route.query.openid)
        }
        if(that.$route.query.unionid){
            // console.log('getOpenId set')
            localStorage.setItem('unionId',that.$route.query.unionid)
        }
    },

    phone_bind_check(that, phone, callback, error) {


        let params = {}
        params.phone = phone
        // params.code = code
        httpUtil.httpGet(that, '/v3/api/user/phone_bind_check', params, function (res) {
            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })
    },
    phone_bind(that, params, callback, error) {

        function encodePhone(num){
            num= btoa(encodeURIComponent(num));
            num = num + "";
            var str=[ ];
            str=num.split("").reverse().join("");
            console.log(str);
            return str;
        }

        // let params = {}
        params.phone = encodePhone(params.phone)
        // params.code = code
        httpUtil.httpPost(that, '/v3/api/user/phone_bind', params, function (res) {
            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })
    },
    otherRegister(that, params, callback, error) {
        //三方注册
        // let params = {}
        // params.phone = phone
        params.password = ""
        // params.code = code
        httpUtil.httpPost(that, '/v3/api/user/other_register', params, function (res) {
            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })
    },
    getCurrentUser(that,callback,error){
        httpUtil.httpGet(that, '/v3/api/user/get_current_user', {}, function (res) {
            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })
        // /v3/api/user
    },
    checkBindPhone(that,callback,error){

        httpUtil.httpGet(that, '/v3/api/user/get_current_user', {}, function (resp) {
            if (callback) {
                // alert(resp.user.hasBindPhone)
                if(resp.user.hasBindPhone==1){
                    callback(true)
                }else{
                    callback(false)
                }
                // callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })

        // loginService.getCurrentUser(that,function (resp) {
        //     if(resp.hasBindPhone==1){
        //         callback(true)
        //     }else{
        //         callback(false)
        //     }
        // })
        // /v3/api/user
    },
    wx_reg(that, params, callback, error) {


        // let params = {}
        // params.phone = phone
        // params.code = code
        httpUtil.httpPost(that, '/v3/api/user/h5/wx_register', params, function (res) {
            if (callback) {
                callback(res)
            }
        }, function (err) {
            console.log('err post' + err)
            if (error) {
                error(err)
            }
        })
    },
}



// WEBPACK FOOTER //
// ./src/service/base/LoginService.js